export default __webpack_public_path__ + "static/Murphy-ba09a8f7ccbd38ae9aab7767cd2ffc7d.png";